import React from 'react';

type ToolbarButtonProps = {
  active?: boolean;
  ariaLabel: string;
  children: React.ReactNode;
  onClick: () => void;
  title?: string;
};

export const ToolbarButton = ({ active, ariaLabel, children, onClick, title }: ToolbarButtonProps) => (
  <button
    type='button'
    className={`tiptapToolbarButton${active ? ' active' : ''}`}
    onMouseDown={e => e.preventDefault()}
    onClick={onClick}
    aria-label={ariaLabel}
    title={title || ariaLabel}
  >
    {children}
  </button>
);
